import { GET_PRODUCTS_FOR_MANUFACTURER } from '@dustin-web/microsite-data/src/graphql/product/get-products-for-manufacturer.graphql'
import { GET_TOP_SELLING_PRODUCTS } from '@dustin-web/microsite-data/src/graphql/product/get-top-selling-products'
import { FacetParameterInput } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { SortBy } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { GetProductsForManufacturerQueryVariables } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

import { ProductLineGridBlock } from '../types/types'
import { CATEGORY_PATH, BRAND, PRODUCT_LINES, BRAND_AND_PRODUCT_LINES } from './aliases'

export const GetVarAndQueryTopSelling = (
  subCriteriaType: string,
  subCriteriaProps: any,
  deffaultNumberOfProducts: number,
  isAvailable?: boolean
) => {
  const query = GET_TOP_SELLING_PRODUCTS
  const variables = {
    numberOfProducts: deffaultNumberOfProducts,
    categoryPath: '',
    facets: [] as FacetParameterInput[],
  }

  isAvailable &&
    variables.facets?.push(
      {
        name: 'isavailableforsale',
        values: ['true'],
      },
      {
        name: 'instock',
        values: ['true'],
      }
    )
  switch (subCriteriaType) {
    case BRAND:
      variables.facets?.push({
        name: 'manufacturer',
        values: [subCriteriaProps.brand],
      })
      break
    case PRODUCT_LINES:
      variables.facets?.push({
        name: 'productline',
        values: subCriteriaProps.productLines?.map(
          (productLine: ProductLineGridBlock) => productLine.properties.stringItem
        ),
      })
      break
    case CATEGORY_PATH:
      variables.categoryPath //: overwriting facets. Deprecated selection
      break
  }
  return {
    query: query,
    variables: variables,
  }
}

export const GetVarAndQueryForManufacturer = (
  subCriteriaType: string,
  subCriteriaProps: any,
  deffaultNumberOfProducts: number,
  isAvailable?: boolean
) => {
  const query = GET_PRODUCTS_FOR_MANUFACTURER
  const variables = {
    page: 1,
    pageSize: deffaultNumberOfProducts,
    selectedCategoryPath: '',
    selectedFacets: [] as FacetParameterInput[],
    sortBy: SortBy.Relevance,
  } as GetProductsForManufacturerQueryVariables

  isAvailable &&
    Array.isArray(variables.selectedFacets) &&
    variables.selectedFacets?.push(
      {
        name: 'isavailableforsale',
        values: ['true'],
      },
      {
        name: 'instock',
        values: ['true'],
      }
    )
  switch (subCriteriaType) {
    case BRAND_AND_PRODUCT_LINES:
      variables.manufacturerName = subCriteriaProps.brand
      Array.isArray(variables.selectedFacets) &&
        subCriteriaProps.productLines?.length &&
        variables.selectedFacets?.push({
          name: 'productline',
          values: subCriteriaProps.productLines?.map(
            (productLine: ProductLineGridBlock) => productLine.properties.stringItem
          ),
        })
  }

  return {
    query: query,
    variables: variables,
  }
}
